import { render, staticRenderFns } from "./FooterPage.vue?vue&type=template&id=1060f4a2&"
import script from "./FooterPage.vue?vue&type=script&lang=ts&"
export * from "./FooterPage.vue?vue&type=script&lang=ts&"
import style0 from "./FooterPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports